import "./new-util-activity-type.scss";

import HeaderContent from "@shared/ui/header-content/header-content";
import { Button } from "primereact/button";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormUtilActivityType from "../form-util-activity-type/form-util-activity-type";
import { useNewUtilActivityType } from "./new-util-activity-type.hook";

export function NewUtilActivityType() {
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewUtilActivityType();

  return (
    <div id="NewUtilActivityType" className="util-activity-type">
      <HeaderContent
        title={<h1>New Activity Type</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormUtilActivityType />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewUtilActivityType;
